import { NavigationItem } from "../types/header.types";

export const MEGA_MENU_ITEMS: NavigationItem[] = [
  // Coluna 1
  {
    id: "a-forluz",
    label: "A Forluz",
    icon: "ico-predio.svg",
    children: [
      { id: "historia", label: "História", href: "/historia" },
      { id: "missao", label: "Missão, Visão e Valores", href: "/missao" },
      { id: "organograma", label: "Organograma", href: "/organograma" },
      { id: "estatuto", label: "Estatuto", href: "/estatuto" },
      { id: "numeros", label: "Forluz em Números", href: "/numeros" },
      { id: "conselhos", label: "Conselhos", href: "/conselhos" },
      { id: "comite", label: "Comitê", href: "/comite" },
      {
        id: "diretoria-executiva",
        label: "Diretoria Executiva",
        href: "/diretoria-executiva",
      },
    ],
  },
  {
    id: "acontece-forluz",
    label: "Acontece na Forluz",
    icon: "ico-dolar.svg",
    children: [
      {
        id: "noticias",
        label: "Notícias",
        href: "/acontece-na-forluz/noticias",
      },
      {
        id: "comunicados",
        label: "Comunicados",
        href: "/acontece-na-forluz/comunicados",
      },
      {
        id: "apresentacoes-especiais",
        label: "Apresentações Especiais",
        href: "/acontece-na-forluz/apresentacoes-especiais",
      },
      {
        id: "publicacoes",
        label: "Publicações",
        href: "/acontece-na-forluz/publicacoes",
      },
      {
        id: "conquistas",
        label: "Conquistas",
        href: "/acontece-na-forluz/conquistas",
      },
      {
        id: "guia-participante",
        label: "Guia do Participante",
        href: "/acontece-na-forluz/guia-participante",
      },
      {
        id: "relatorio-anual",
        label: "Relatório Anual de Informações",
        href: "/acontece-na-forluz/relatorio-anual-informacoes",
      },
      {
        id: "beneficio-participante", //calendário de pagamento de benefício para os participantes
        label: "Calendário de Pagamento de Benefício",
        href: "/acontece-na-forluz/beneficio-participante",
      },
    ],
  },
  {
    id: "para-viver-melhor",
    label: "Para Viver Melhor",
    href: "/ViverMelhor/para-viver-melhor",
    icon: "ico-viver.svg",
  },
  {
    id: "forluzgo",
    label: "ForluzGO!",
    href: "https://forluzgo.com.br",
    icon: "ico-dice.svg",
    external: true,
  },

  // Coluna 2
  {
    id: "plano-a",
    label: "Plano A",
    icon: "ico-a.svg",
    children: [
      { id: "plano-a-descricao", label: "Descrição", href: "/PlanoA/plano-a" },
      {
        id: "plano-a-regulamento",
        label: "Regulamento",
        href: "/PlanoA/plano-a-regulamento",
      },
      {
        id: "plano-a-rentabilidades",
        label: "Rentabilidade",
        href: "/PlanoA/plano-a-rentabilidades",
      },
      {
        id: "plano-a-demonstracao",
        label: "Demonstração Atuarial",
        href: "/PlanoA/Demonstracao-Atuarial",
      },
      {
        id: "plano-a-hotsite",
        label: "Hotsite do Plano A",
        href: "https://hotsiteplanoa.forluz.org.br",
        external: true,
      },
    ],
  },
  {
    id: "plano-b",
    label: "Plano B",
    icon: "ico-b.svg",
    children: [
      {
        id: "plano-b-descricao",
        label: "Descrição",
        href: "/PlanoB/plano-b-descricao",
      },
      {
        id: "plano-b-regulamento",
        label: "Regulamento",
        href: "/PlanoB/plano-b-regulamento",
      },
      {
        id: "plano-b-cartilha",
        label: "Cartilha do Participante",
        href: "/PlanoB/plano-b-cartilha",
      },
      {
        id: "plano-b-rentabilidades",
        label: "Rentabilidade",
        href: "/PlanoB/plano-b-rentabilidades",
      },
      {
        id: "plano-b-demonstracao",
        label: "Demonstração Atuarial",
        href: "/PlanoB/Demonstracao-Atuarial",
      },
    ],
  },
  {
    id: "plano-taesaprev",
    label: "Plano TaesaPrev",
    icon: "ico-t.svg",
    children: [
      {
        id: "taesaprev-descricao",
        label: "Descrição",
        href: "/PlanoTaesaprev/plano-taesaprev-descricao",
      },
      {
        id: "taesaprev-regulamento",
        label: "Regulamento",
        href: "/PlanoTaesaprev/plano-taesaprev-regulamento",
      },
      {
        id: "taesaprev-cartilha",
        label: "Cartilha do Participante",
        href: "/PlanoTaesaprev/plano-taesaprev-cartilha",
      },
      {
        id: "taesaprev-rentabilidades",
        label: "Rentabilidade",
        href: "/PlanoTaesaprev/plano-taesaprev-rentabilidades",
      },
      {
        id: "taesaprev-demonstracao",
        label: "Demonstração Atuarial",
        href: "/PlanoTaesaprev/Demonstracao-Atuarial",
      },
    ],
  },
    {
    id: "adesao",
    label: "Desejo me filiar",
    href: "https://adesao.forluz.org.br",
    icon: "ico-assinatura.svg",
    external: true,
  },

  // Coluna 3
  {
    id: "investimentos",
    label: "Investimentos",
    icon: "ico-investimento.svg",
    children: [
      {
        id: "politica-investimentos",
        label: "Política de Investimentos",
        href: "/Investimentos/politica-investimentos",
      },
      {
        id: "demonstracoes-financeiras",
        label: "Demonstrações Financeiras",
        href: "/Investimentos/demonstracoes-financeiras",
      },
      {
        id: "demonstrativos-contabeis",
        label: "Demonstrativos Contábeis",
        href: "/Investimentos/demonstrativos-contabeis",
      },
      {
        id: "demonstrativos-investimentos",
        label: "Demonstrativos de Investimentos",
        href: "/Investimentos/demonstrativos-de-investimentos",
      },
      {
        id: "perfil-investimento",
        label: "Perfil de Investimento",
        href: "/Investimentos/perfil-de-investimento",
      },
      {
        id: "calculadora-aporte",
        label: "Calculadora de Aporte",
        href: "/Investimentos/calculadora-de-aporte",
      },
      {
        id: "calculadora-contribuicao",
        label: "Calculadora de Contribuição",
        href: "/Investimentos/calculadora-de-contribuicao",
      },
      {
        id: "calculadora-deduzir",
        label: "DeduzIR",
        href: "/Calculadora/calculadora-deduzir",
      },
    ],
  },
  {
    id: "emprestimos",
    label: "Empréstimos",
    href: "/emprestimos",
    icon: "ico-mao.svg",
  },
  {
    id: "transparencia",
    label: "Transparência",
    icon: "ico-pasta.png",
    children: [
      {
        id: "extrato-tac",
        label: "Extrato TAC",
        href: "/Transparencia/extrato-tac",
      },
      {
        id: "acesso-informacao",
        label: "Acesso à Informação",
        href: "/Transparencia/acesso-informacao",
      },
      {
        id: "plano-gestao",
        label: "Plano de Gestão Administrativa",
        href: "/Transparencia/plano-de-gestao-administrativa",
      },
    ],
  },
  {
    id: "compliance-governanca",
    label: "Compliance e Governança",
    icon: "ico-livro.svg",
    children: [
      {
        id: "politica-gov-corporativa",
        label: "Política de Gov. Corporativa",
        href: "/Governanca/politica-gov-corporativa",
      },
      {
        id: "politica-pld-ft",
        label: "Política de PLD/FT",
        href: "/Governanca/politica-lavagem-terrorismo",
      },
      {
        id: "codigo-etica",
        label: "Código de Conduta e Ética",
        href: "/Governanca/codigo-etica",
      },
      {
        id: "canal-denuncia",
        label: "Canal de Denúncia",
        href: "/Governanca/canal-de-denuncia",
      },
      {
        id: "programa-compliance",
        label: "Programa de Compliance",
        href: "/Governanca/programa-de-compliance",
      },
      { id: "lgpd", label: "LGPD", href: "/Governanca/lgpd" },
    ],
  },
  {
    id: "gestao-riscos",
    label: "Gestão de Riscos",
    href: "/gestaoderisco",
    icon: "ico-escudo.svg",
  },

  // Coluna 4
  {
    id: "central-atendimento",
    label: "Central de Atendimento",
    href: "/CentralDeAtendimento/central-atendimento",
    icon: "ico-fone.svg",
  },
  {
    id: "gestao-pessoas",
    label: "Gestão de Pessoas",
    icon: "ico-person.svg",
    children: [
      {
        id: "nossas-praticas",
        label: "Nossas práticas",
        href: "/Contato/nossas-praticas",
      },
      {
        id: "trabalhe-conosco",
        label: "Trabalhe Conosco",
        href: "/Contato/trabalhe-conosco",
      },
    ],
  },
  {
    id: "formularios",
    label: "Formulários",
    href: "/formularios",
    icon: "ico-form.svg",
  },
];

export const HEADER_HEIGHT = 93;
export const SEARCH_PLACEHOLDER = "O que você procura?";
